/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationDocumentType as CommonUtilitiesApplicationDocumentType } from '../../models/CommonUtilities/application-document-type';
import { VehicleLoanFileRequestBaseResponse as ModelsV3ApplicationVehicleLoanFileRequestBaseResponse } from '../../models/Models/v3/Application/vehicle-loan-file-request-base-response';

export interface V3ApplicationVehicleApplicationIdFilePost$Xml$Params {
  applicationId: string;
      body?: {
'FileName': string;
'DocumentType': CommonUtilitiesApplicationDocumentType;
'formFiles'?: Array<Blob>;
}
}

export function v3ApplicationVehicleApplicationIdFilePost$Xml(http: HttpClient, rootUrl: string, params: V3ApplicationVehicleApplicationIdFilePost$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationVehicleLoanFileRequestBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3ApplicationVehicleApplicationIdFilePost$Xml.PATH, 'post');
  if (params) {
    rb.path('applicationId', params.applicationId, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3ApplicationVehicleLoanFileRequestBaseResponse>;
    })
  );
}

v3ApplicationVehicleApplicationIdFilePost$Xml.PATH = '/v3/application/vehicle/{applicationId}/file';
